import axios from "axios";
import { ElMessage } from 'element-plus'

// 充值/调减接口接口
export async function rechargeFun(params, type) {
    const url = type == 1 ? '/api/bms/balance/add' : '/api/bms/balance/reduce';
    return new Promise((resolve, reject) => {
        axios.put(url, params).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 查询充值用户列表
export async function getRechargeListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/balance?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 查询充值/调减记录列表
export async function getRechargeRecordFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/balanceLog?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}